import React, { useCallback } from 'react';
import {  useNavigate } from 'react-router-dom';

function NotFoundPage({
  title = 'Page not found',
  message = "The page you're looking for doesn't exist or may have moved.",
  ctaLabel = 'Go Back',
}) {
  const navigate = useNavigate();
  const onBack = useCallback(() => {
    navigate(-1)
  },[navigate])
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        <p className="text-sm font-semibold text-blue-700 mb-2">404</p>
        <h1 className="text-3xl font-bold text-gray-900 mb-3">{title}</h1>
        <p className="text-gray-600 mb-6">{message}</p>
        <button
          onClick={onBack}
          className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-blue-700 text-white hover:bg-blue-600 transition-colors"
        >
          {ctaLabel}
        </button>
      </div>
    </div>
  );
}

export default NotFoundPage;
